import {
  updateExpandedFolder,
  updateFolder,
  removeFolder,
  addFolder,
  addPendingTreeNode,
  removePendingTreeNode,
  updateTreeNode,
  updatePendingTreeNode,
  setHiddenRootFolder
} from '../helpers';
import { ACTION_TYPE } from '../helpers/consts';
import { StateType, UserType } from '../types';

const initFolderState = {
  folders: [],
  treeState: {},
  loading: true,
  hasError: false
};

export const initState: StateType = {
  ...initFolderState,
  user: {} as UserType
};

export const reducer = (
  state: StateType,
  {
    type,
    payload
  }: {
    type: string;
    payload?: any;
  }
): StateType => {
  switch (type) {
    case ACTION_TYPE.LOAD_TOP_FOLDERS_START:
      return {
        ...state,
        ...initFolderState
      };
    case ACTION_TYPE.LOAD_TOP_FOLDERS_ERROR:
      return {
        ...state,
        loading: false,
        hasError: true,
        resStatus: payload
      };
    case ACTION_TYPE.LOAD_TOP_FOLDERS_END:
      return {
        ...state,
        loading: false,
        folders: payload
      };
    case ACTION_TYPE.SET_HIDDEN_ROOT_FOLDER:
      return {
        ...state,
        treeState: setHiddenRootFolder(state.treeState, payload.hiddenFolder)
      };
    case ACTION_TYPE.EXPAND_FOLDER:
      return {
        ...state,
        folders: updateExpandedFolder(state.folders, payload.folderUrn, payload.folders)
      };

    case ACTION_TYPE.UPDATE_FOLDER:
      return {
        ...state,
        folders: updateFolder(state.folders, payload.folderUrn, payload.folder)
      };

    case ACTION_TYPE.DELETE_FOLDER:
      return {
        ...state,
        folders: removeFolder(state.folders, payload.folderUrn)
      };

    case ACTION_TYPE.CREATE_FOLDER:
      return {
        ...state,
        folders: addFolder(state.folders, state.treeState, payload.parentUrn, payload.folder)
      };

    case ACTION_TYPE.ADD_PENDING_TREE_NODE:
      return {
        ...state,
        treeState: addPendingTreeNode(state.treeState, state.folders, payload.parentUrn, payload.nodeNameGenerator)
      };

    case ACTION_TYPE.REMOVE_PENDING_TREE_NODE:
      return {
        ...state,
        treeState: removePendingTreeNode(state.treeState, payload.parentUrn, payload.folderUrn, payload.dropKeys)
      };

    case ACTION_TYPE.UPDATE_PENDING_TREE_NODE:
      return {
        ...state,
        treeState: updatePendingTreeNode(state.treeState, payload.parentUrn, payload.folderUrn, payload.folder)
      };

    case ACTION_TYPE.UPDATE_TREE_NODE:
      return {
        ...state,
        treeState: updateTreeNode(state.treeState, payload.folderUrn, payload.folder, payload.dropKeys)
      };

    case ACTION_TYPE.SET_USER:
      return {
        ...state,
        user: payload
      };

    default:
      return state;
  }
};
